import { changeCustomerValue } from '../../slices';
import { connectCheckoutField } from '../../utils/connectCheckoutField';

export const inject = connectCheckoutField({
    defaultName: 'sendReservationSms',
    defaultValue: false,
    valueKey: 'checked',
    // @ts-expect-error $TSFixMeError: Parameter 'dispatch' implicitly has an 'any' type.
    mapAdditionalDispatchProps: (dispatch, { name }: $TSFixMe) => ({
        onChange: (_: $TSFixMe, checked: $TSFixMe) => dispatch(changeCustomerValue({ key: name, value: checked })),
    }),
});
